import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=4ab4ff89&"
import script from "./successPage.vue?vue&type=script&lang=js&"
export * from "./successPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports